export enum DesignSettingsChangesActions {
  REMOVED = 'Removed',
  ADDED = 'Added',
  CHANGED = 'Changed',
  SET_AS_DEFAULT = 'Set as Default',
  VIEWED = 'Viewed',
  DUPLICATE = 'Duplicate',
  USED = 'Used',
  SAVED_SETTINGS = 'Saved Settings',
}
